import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import ProviderAnalyticsEdit, { DispatchProps, OwnProps, StateProps } from './ProviderAnalyticsEditScreen';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getSeances, getSeancesCsv } from 'src/store/actions/seance-actions';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';
import { selectNameStudents } from '../../../../../../store/selectors/students-selectors';
import { getProvider, getProvidersSmall } from '../../../../../../store/actions/provider-actions';
import { getStudentsSmall } from '../../../../../../store/actions/student-actions';
import { getVendorsSmall } from '../../../../../../store/actions/vendor-actions';
import { getDistrictsSmall } from '../../../../../../store/actions/district-actions';
import { selectNameDistricts } from '../../../../../../store/selectors/districts-selectors';
import { selectNameVendors } from '../../../../../../store/selectors/vendors-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.seances.data,
        inProgress: state.seances.inProgress,
        providers: selectNameProviders(state),
        students: selectNameStudents(state),
        districts: selectNameDistricts(state),
        vendors: selectNameVendors(state),
        inProgressCSV: state.seances.inProgressCSV,
        provider: state.providers.current,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getProviderData: (id) => dispatch(getProvider(id)),
        getData: (params: QueryParams) => dispatch(getSeances(params)),
        getDataCsv: (params: QueryParams) => dispatch(getSeancesCsv(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
        getStudents: (params: QueryParams) => dispatch(getStudentsSmall(params)),
        getDistricts: (params: QueryParams) => dispatch(getDistrictsSmall(params)),
        getVendors: (params: QueryParams) => dispatch(getVendorsSmall(params)),
    };
}

const ProviderAnalyticsEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ProviderAnalyticsEdit);

export default ProviderAnalyticsEditScreen;
